import type { RatesPricingState } from './common.types';

const initialCustomerFilter = {
  id: 'residential',
  name: 'Home',
  disabled: false,
};
const initialEnergyFilter = {
  id: '',
  name: 'Electricity & Gas',
  disabled: false,
};
const initialTariffFilter = {
  id: '',
  name: 'All tariff types',
  disabled: false,
};
const initialPlanFilter = {
  id: '',
  name: 'All energy plans',
  disabled: false,
};

const initialState: RatesPricingState = {
  items: [],
  options: {
    customerType: [
      initialCustomerFilter,
      {
        id: 'business',
        name: 'Work',
        disabled: false,
      },
    ],
    energyType: [
      initialEnergyFilter,
      {
        id: 'electricity',
        name: 'Electricity',
        disabled: false,
      },
      {
        id: 'gas',
        name: 'Gas',
        disabled: false,
      },
    ],
    tariffType: [initialTariffFilter],
    planName: [initialPlanFilter],
  },
  filters: {
    customerType: initialCustomerFilter,
    energyType: initialEnergyFilter,
    tariffType: initialTariffFilter,
    planName: initialPlanFilter,
  },
};

export default initialState;
